import { HttpParameterCodec } from '@angular/common/http';

/**
 * Codec que codifica por completo con encodeURIComponent. El codec por defecto de
 * Angular NO codifica el '+', y el servidor lo interpretaría como espacio — rompiendo
 * filtros como `phonePrefix` (ej. '+51' llegaría como ' 51'). Con este codec, '+' → '%2B'.
 */
export class FullHttpParameterCodec implements HttpParameterCodec {
  encodeKey(key: string): string { return encodeURIComponent(key); }
  encodeValue(value: string): string { return encodeURIComponent(value); }
  decodeKey(key: string): string { return decodeURIComponent(key); }
  decodeValue(value: string): string { return decodeURIComponent(value); }
}
